/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../Fixes';
import Builder from '../../../Builder';
import './event_type';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "connect": {
        "nested": {
          "v2": {
            "nested": {
              "DeviceEvent": {
                "fields": {
                  "eventId": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "eventType": {
                    "type": ".squareup.connect.v2.DeviceEventType",
                    "id": 2,
                    "rule": "optional"
                  },
                  "eventPriority": {
                    "type": ".squareup.connect.v2.DeviceEvent.DeviceEventPriority",
                    "id": 3,
                    "rule": "optional"
                  }
                },
                "nested": {
                  "DeviceEventPriority": {
                    "values": {
                      "INVALID_DEVICE_EVENT_PRIORITY": 0,
                      "DEVICE_READY": 1,
                      "DEVICE_WARNING": 2,
                      "DEVICE_CRITICAL": 3
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.connect?.nested?.v2?.nested?.DeviceEvent && !$root.nested?.squareup?.nested?.connect?.nested?.v2?.nested?.DeviceEvent?.nested?.DeviceEventPriority) {
  $root.addJSON(jsonData);
}

/**
 * SOURCE DeviceEvent @ squareup/devices/external/device_event.proto at 12:1
 */
export const DeviceEvent = $root.lookupType('squareup.connect.v2.DeviceEvent');
fixType(DeviceEvent);
Builder.createAndAttachToType(DeviceEvent);
/**
 * SOURCE DeviceEventPriority @ squareup/devices/external/device_event.proto at 17:3
 */
DeviceEvent.DeviceEventPriority = $root.lookupEnum('squareup.connect.v2.DeviceEvent.DeviceEventPriority').values;